import React from 'react';
import { IconProps } from './types';

export const EmailVerificationIcon: React.FC<IconProps> = (props) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* Envelope body */}
    <path d="M12 30L40 50L68 30V65C68 67.2 66.2 69 64 69H16C13.8 69 12 67.2 12 65V30Z" fill="#2196F3" />
    {/* Envelope flap */}
    <path d="M12 30L40 50L68 30L64 25H16L12 30Z" fill="#42A5F5" />
    {/* Letter */}
    <rect x="24" y="12" width="32" height="36" rx="3" fill="#E0E0E0" />
    {/* Letter lines */}
    <rect x="30" y="20" width="20" height="3" rx="1.5" fill="#BDBDBD" />
    <rect x="30" y="27" width="14" height="3" rx="1.5" fill="#BDBDBD" />
    {/* Exclamation circle */}
    <circle cx="40" cy="38" r="8" fill="#FF9800" />
    <rect x="39" y="33" width="2" height="6" rx="1" fill="white" />
    <circle cx="40" cy="42" r="1.2" fill="white" />
  </svg>
);
